(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-ssg-slide-label]').forEach((dots) => {
      if (dots.dataset.ssgLabelsReady) return;
      dots.dataset.ssgLabelsReady = 'true';
      const labelButtons = () => {
        dots.querySelectorAll('button').forEach((button, index) => {
          button.setAttribute('aria-label', dots.dataset.ssgSlideLabel.replace('__slide__', String(index + 1)));
        });
      };
      labelButtons();
      new MutationObserver(labelButtons).observe(dots, { childList: true, subtree: true });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
